import React from 'react';
import { Link } from 'react-router-dom';

export default function Collection() {
  return (
    <main style={{ background: '#f7f3ea', minHeight: '100vh', padding: '72px 24px' }}>
      <section style={{ maxWidth: '1120px', margin: '0 auto' }}>
        <span style={{ display: 'inline-block', marginBottom: '14px', fontSize: '10px', letterSpacing: '3px', textTransform: 'uppercase', color: '#7a673f', fontWeight: 700 }}>
          Since 1965
        </span>
        <h1 style={{ margin: '0 0 14px', fontFamily: 'Noto Serif, Georgia, serif', fontWeight: 400, fontSize: 'clamp(2rem, 4.2vw, 3.2rem)', color: '#1b1c15' }}>
          Kaaleen Haus Collection
        </h1>
        <p style={{ margin: '0 0 34px', maxWidth: '680px', color: '#4d473c', lineHeight: 1.7 }}>
          A curated lineup of handwoven pieces with modern proportions, artisanal detailing, and enduring textures.
          The full filter and offer engine will be connected in the next step.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '18px', marginBottom: '28px' }}>
          {['Atelier Neutrals', 'Heritage Classics', 'Modern Geometry', 'Architectural Luxe'].map((name) => (
            <article key={name} style={{ background: '#fff', border: '1px solid #e8dfcf', borderRadius: '12px', padding: '22px' }}>
              <h3 style={{ margin: '0 0 8px', fontFamily: 'Noto Serif, Georgia, serif', fontWeight: 400, color: '#2f2a22' }}>{name}</h3>
              <p style={{ margin: 0, fontSize: '14px', color: '#756e61' }}>Collection block ready for product mapping.</p>
            </article>
          ))}
        </div>

        <Link to="/shop" style={{ display: 'inline-block', padding: '12px 22px', background: '#7d5e12', color: '#fff', textDecoration: 'none', fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', fontWeight: 700 }}>
          Continue To Shop
        </Link>
      </section>
    </main>
  );
}
